import { render, staticRenderFns } from "./appFooter.vue?vue&type=template&id=5f4b396b&scoped=true&"
var script = {}
import style0 from "./appFooter.vue?vue&type=style&index=0&id=5f4b396b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4b396b",
  null
  
)

export default component.exports